import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function formatDate(iso?: string | null): string {
  if (!iso) return '-';
  return dayjs(iso).format('DD/MM/YYYY HH:mm');
}

export function formatDateOnly(iso?: string | null): string {
  if (!iso) return '-';
  return dayjs(iso).format('DD/MM/YYYY');
}

export function formatRelative(iso: string): string {
  return dayjs(iso).fromNow();
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function versionStatusLabel(status: string): string {
  const map: Record<string, string> = {
    INITIAL: 'Khởi tạo',
    DRAFT: 'Bản nháp',
    SUBMITTED: 'Đã gửi duyệt',
    IN_REVIEW: 'Đang xét duyệt',
    CHANGES_REQUESTED: 'Yêu cầu chỉnh sửa',
    APPROVED: 'Đã phê duyệt',
    PUBLISHED: 'Đã xuất bản',
    UNPUBLISHED: 'Đã gỡ',
    REJECTED: 'Bị từ chối',
    DEPRECATED: 'Đã cũ',
  };
  return map[status] || status;
}

export function partnerStatusLabel(status: string): string {
  const map: Record<string, string> = {
    ACTIVE: 'Hoạt động',
    SUSPENDED: 'Tạm đình chỉ',
    INACTIVE: 'Ngừng hoạt động',
  };
  return map[status?.toUpperCase()] || status;
}

export function appTypeLabel(type: string): string {
  const map: Record<string, string> = {
    web_app: 'WebApp',
    apk_app: 'Feature App',
    app2app: 'App2App',
    mini_app: 'MiniApp',
    include_app: 'AppModule',
    hybrid_app: 'HybridApp',
    // Aliases
    WEB_APP: 'WebApp',
    FEATURE_APP: 'Feature App',
    APP2APP: 'App2App',
    MINI_APP: 'MiniApp',
    APP_MODULE: 'AppModule',
    HYBRID_APP: 'HybridApp',
    WebApp: 'WebApp',
    FeatureApp: 'Feature App',
    MiniApp: 'MiniApp',
    AppModule: 'AppModule',
    HybridApp: 'HybridApp',
  };
  return map[type] || type;
}

export function sensitivityLabel(level: string): string {
  const map: Record<string, string> = {
    NORMAL: 'Bình thường',
    DANGEROUS: 'Nguy hiểm',
    SIGNATURE: 'Cần chữ ký số',
  };
  return map[level] || level;
}
